<template>
  <main class="pb-5 mb-5">
    <section class="pt-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1>Welcome to Global Talks</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="container mt-5" v-if="loading">
      <div class="row">
        <div class="col text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </section>

    <event :id="firstEvent.id" :show-header="false" v-if="!loading && firstEvent"></event>
  </main>
</template>

<script>
  import { firebase } from "@/initializers/firebase"
  import Event from "./event.vue"

  export default {
    name: "home",
    components: { Event },
    data() {
      return {
        loading: true,
        sending: false,
        events: []
      }
    },
    computed: {
      firstEvent() {
        return this.events[0]
      }
    },
    async mounted() {
      let eventsRef = await firebase.firestore().collection(`events`).where("active", "==", true).orderBy("eventStart")
      let events = await eventsRef.get()
      this.events = events.docs.map((doc) => {
        return Object.assign({}, { id: doc.id }, doc.data())
      })

      this.loading = false
    }
  }
</script>

<style lang="scss" scoped>
  
</style>